// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "../tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as React from "react";
import * as TftSet from "../data/TftSet.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "../atoms/ScreenAtom.bs.js";
import * as TraitImage from "../tft-static/TraitImage.bs.js";
import * as TraitTooltip from "../tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";

function TraitsRow(Props) {
  var smallOpt = Props.small;
  var traits = Props.traits;
  var classNameOpt = Props.className;
  var chosenTraitsOpt = Props.chosenTraits;
  var small = smallOpt !== undefined ? smallOpt : false;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var chosenTraits = chosenTraitsOpt !== undefined ? chosenTraitsOpt : [];
  var set = TftSet.use(undefined);
  var screenSize = ScreenAtom.use(undefined);
  var maxTraitCount = screenSize >= 5 ? 7 : 11;
  var traits$1 = traits.length > maxTraitCount ? Belt_Array.keep(traits, (function (param) {
            return !Sd.isTraitUnique(param[0], set);
          })) : traits;
  return React.createElement("div", {
              className: "flex pt-[2px] sm:justify-end " + className
            }, Belt_Array.mapWithIndex(Belt_SortArray.stableSortBy(traits$1, (function (param, param$1) {
                        var r2 = param$1[1];
                        var t2 = param$1[0];
                        var r1 = param[1];
                        var t1 = param[0];
                        var s1 = Sd.traitStyle(t1, r1, set);
                        var s2 = Sd.traitStyle(t2, r2, set);
                        var c1 = Sd.traitRankUnitCount(t1, r1, set);
                        var c2 = Sd.traitRankUnitCount(t2, r2, set);
                        var c = Caml.caml_int_compare(s2, s1);
                        if (c !== 0) {
                          return c;
                        } else {
                          return Caml.caml_int_compare(c2, c1);
                        }
                      })), (function (idx, param) {
                    var rank = param[1];
                    var trait = param[0];
                    var count = Sd.traitRankUnitCount(trait, rank, set);
                    return React.createElement(TraitTooltip.make, {
                                trait: trait,
                                rank: rank,
                                children: React.createElement("div", {
                                      key: String(idx),
                                      className: "relative flex items-center select-none" + (
                                        idx === 0 ? "" : " ml-[5px]"
                                      )
                                    }, React.createElement(TraitImage.PlainIcon.make, {
                                          traitId: trait,
                                          rank: rank,
                                          size: small ? 15 : 17
                                        }), React.createElement("div", {
                                          className: "font-medium pl-[1px] pt-[1px] font-montserrat font-semibold" + (
                                            small ? "text-[14px]" : ""
                                          )
                                        }, String(count)), chosenTraits.includes(trait) ? React.createElement("img", {
                                            className: "absolute left-[7px] bottom-[-1px] w-[12px] h-[12px]",
                                            height: "12",
                                            src: "https://ap.tft.tools/img/general/headliner.png?w=12",
                                            width: "12"
                                          }) : null),
                                key: String(idx)
                              });
                  })));
}

var make = TraitsRow;

export {
  make ,
  
}
/* Sd Not a pure module */
